import { AskResponse, Citation } from "../../api";
import { cloneDeep } from "lodash-es";

type ParsedAnswer = {
  citations: Citation[];
  markdownFormatText: string;
  intent: string;
};

let filteredCitations = [] as Citation[];

// Define a function to check if a citation with the same title already exists in filteredCitations
const isDuplicate = (citation: Citation) => {
  return (
    citation !== undefined &&
    citation.title &&
    filteredCitations.some((c) => c.title === citation.title)
  );
};

export function parseAnswer(answer: AskResponse): ParsedAnswer {
  let answerText = answer.answer;
  const citationLinks = answerText.match(/\[(doc\d\d?\d?)]/g);

  const lengthDocN = "[doc".length;

  filteredCitations = [] as Citation[];
  let citationReindex = 0;
  citationLinks?.forEach((link) => {
    // Replacing the links/citations with number
    let citationIndex = link.slice(lengthDocN, link.length - 1);
    let citation = cloneDeep(
      answer.citations[Number(citationIndex) - 1],
    ) as Citation;
    // if not valid citation remove the link
    if (!citation) {
      answerText = answerText.replaceAll(link, "");
      return;
    }
    // if title includes /documents/ remove it
    if (citation && citation.title && citation.title.includes("/documents/")) {
      citation.title = citation.title.replace("/documents/", "");
    }
    if (citation && citation.title && !isDuplicate(citation)) {
      answerText = answerText.replaceAll(link, ` ^${++citationReindex}^ `);
      citation.id = citationIndex; // original doc index to de-dupe
      citation.reindex_id = citationReindex.toString(); // reindex from 1 for display
      filteredCitations.push(citation);
    } else {
      // Replacing duplicate citation with original index
      let matchingCitation = filteredCitations.find(
        (ct) => citation && citation.title == ct.title,
      );
      if (matchingCitation) {
        answerText = answerText.replaceAll(
          link,
          ` ^${matchingCitation.reindex_id}^ `,
        );
      }
    }
  });

  return {
    citations: filteredCitations,
    markdownFormatText: answerText,
    intent: answer.intent,
  };
}
